export const setCountryResidence = (state, countryResidence) => {
  state.countryResidence = countryResidence;
};

export default {
  setCountryResidence,
};
